import { render, staticRenderFns } from "./RegionManagerView.vue?vue&type=template&id=421d392e&scoped=true"
import script from "./RegionManagerView.vue?vue&type=script&lang=js"
export * from "./RegionManagerView.vue?vue&type=script&lang=js"
import style0 from "./RegionManagerView.vue?vue&type=style&index=0&id=421d392e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421d392e",
  null
  
)

export default component.exports